/**
 * @file コンポーネント：ログアウトモーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// 関数読み込み
import { fnSetFixedBody } from "~/src/functions/common";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "cancel",
                    onClick: (e) => {
                        e.preventDefault();
                        fnSetFixedBody(false);
                        props.setIsOpenModalLogout(false);
                    },
                    text: localized["Label.Cancel"],
                },
                {
                    buttonType: "caution",
                    href: "/logout",
                    text: localized["Label.Logout"],
                },
            ]}
            content={[
                <Paragraph
                    key="content"
                    onColor="white"
                    text={localized["Label.LogoutMessage"]}
                />,
            ]}
            hasButtonClose={true}
            isShow={props.isOpenModalLogout}
            setIsShow={props.setIsOpenModalLogout}
        />
    );
};
